import React, {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import MenuController from '@/controllers/MenuController'
import LogController from '@/controllers/Logging/LogController'
import { Avatar } from '@/components/avatar'
import PathConstants from '@/routes/pathConstants'
import { checkAbility } from "@/Events/CheckAbilityEvent";
import CalenderEventWidget from '@/views/widgets/CalenderEventWidget';

import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from '@/components/dropdown'
import { Navbar, NavbarItem, NavbarSection, NavbarSpacer } from '@/components/navbar'
import {
  Sidebar,
  SidebarBody,
  SidebarFooter,
  SidebarHeader,
  SidebarHeading,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarSpacer,
} from '@/components/sidebar'
import { SidebarLayout } from '@/components/sidebar-layout'
import {
  ArrowRightStartOnRectangleIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  Cog8ToothIcon,
  LightBulbIcon,
  PlusIcon,
  ShieldCheckIcon,
  UserIcon,
} from '@heroicons/react/16/solid'
import {
  Cog6ToothIcon,
  HomeIcon,
  InboxIcon,
  MagnifyingGlassIcon,
  MegaphoneIcon,
  QuestionMarkCircleIcon,
  SparklesIcon,
  Square2StackIcon,
  TicketIcon,
} from '@heroicons/react/20/solid'

import {PPC_Dropdown as PPCDropDown} from "@/views/base/tenant/Dropdown";

import { useDispatch } from 'react-redux'
import {logoutUser, checkUserAuth} from "@/reducers/Authorisation"

import * as UserConst from "actions/userConst";
import { useTranslation, withTranslation, Trans } from "react-i18next";
export default function App({...props}) {
    const navigate = useNavigate();
    const { t, i18n, ready } = useTranslation();
const dispatch = useDispatch();
    const logout  = (event) => {
        event.stopPropagation();
        event.preventDefault()

    
    dispatch( logoutUser() );
    return false;
    }
    
    const addNewTenant = (event) => {
        //event.stopPropagation();
        //event.preventDefault()

        navigate(PathConstants.TENANT_ADD);        
//        dispatch( logoutUser() );
        return false;
    }

useEffect(() => {
                if(props.authReducer.isAuth === false && props.authReducer.status == UserConst.USER_STATE_INIT) {
                //await store.dispatch(checkUserAuth());
                dispatch( checkUserAuth() );
            }
        
    });

    let username = "";
    let tenantName = "";
    let tenantId = 0;
    if(props.authReducer && props.authReducer.user && props.authReducer.user) {
        username = props.authReducer.user.initials+" "+props.authReducer.user.last_name;
    }
    if(props.authReducer && props.authReducer.tenant && props.authReducer.tenant.name) {
        tenantName = props.authReducer.tenant.name;
        tenantId = props.authReducer.tenant.key;
    }
  return (
    <SidebarLayout
      navbar={
        <Navbar>
          <NavbarSpacer />
          <NavbarSection>
            <NavbarItem href="/search" aria-label="Search">
              <MagnifyingGlassIcon />
            </NavbarItem>
            <NavbarItem href="/inbox" aria-label="Inbox">
              <InboxIcon />
            </NavbarItem>
            {username != "" && 
            <Dropdown>
              <DropdownButton as={NavbarItem}>
                  <span className="min-w-0">
                    <span className="block truncate text-sm/5 font-medium text-zinc-950 dark:text-white">{props.authReducer.user.first_name}</span>
                    <span className="block truncate text-xs/5 font-normal text-zinc-500 dark:text-zinc-400">
                      {props.authReducer.user.email}
                    </span>
                  </span>
              </DropdownButton>
              <DropdownMenu className="min-w-64" anchor="bottom end">
                <DropdownItem href="/my-profile">
                  <DropdownLabel>My profile</DropdownLabel>
                </DropdownItem>
                <DropdownItem href="/settings">
                  <Cog8ToothIcon />
                  <DropdownLabel>Settings</DropdownLabel>
                </DropdownItem>
                <DropdownDivider />
                <DropdownItem href="/privacy-policy">
                  <ShieldCheckIcon />
                  <DropdownLabel>Privacy policy</DropdownLabel>
                </DropdownItem>
                <DropdownItem href="/share-feedback">
                  <LightBulbIcon />
                  <DropdownLabel>Share feedback</DropdownLabel>
                </DropdownItem>
                <DropdownDivider />
                <DropdownItem href="/logout">
                  <ArrowRightStartOnRectangleIcon />
                  <DropdownLabel>Sign out</DropdownLabel>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            }
          </NavbarSection>
        </Navbar>
      }
      sidebar={
        <Sidebar id="menuBar">
          <SidebarHeader>
          {props.authReducer &&
          props.authReducer?.tenants && 
          props.authReducer?.tenants.length > 0 &&
            <Dropdown>
              <DropdownButton as={SidebarItem} className="lg:mb-2.5">
                <SidebarLabel key={tenantId}>{tenantName}</SidebarLabel>
                { 1 == 1 &&
                <ChevronDownIcon />
                }
              </DropdownButton>
                { 1 == 1 &&
              <DropdownMenu className="min-w-80 lg:min-w-64" anchor="bottom start">
                    <PPCDropDown data={props.authReducer.tenants} selected={tenantId}/>                
                {checkAbility('tenant', '**') &&
                <>
                <DropdownDivider />
                <DropdownItem onClick={(ev) => addNewTenant(ev)}>
                  <PlusIcon />
                  <DropdownLabel>Nieuw bedrijf&hellip;</DropdownLabel>
                </DropdownItem>
                </>
                }
              </DropdownMenu>
                }
            </Dropdown>
            }
          {props.authReducer &&
          props.authReducer.tenants && 
          props.authReducer.tenants.length > 1000 &&
              <SidebarItem>
                <SidebarLabel>&nbsp;</SidebarLabel>
              </SidebarItem>
            }
            <SidebarSection className="max-lg:hidden hidden">
              <SidebarItem href="/search">
                <MagnifyingGlassIcon />
                <SidebarLabel>Zoeken</SidebarLabel>
              </SidebarItem>
              <SidebarItem href="/inbox">
                <InboxIcon />
                <SidebarLabel>Inbox</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
          </SidebarHeader>
          <SidebarBody>
            <SidebarSection>
            {props?.authReducer?.menu.map((menuItem) => {
                let menuLbl = menuItem.label;
                let transLbl = "menu."+menuItem.key;
                if(transLbl != t(transLbl)) {
                    menuLbl = t(transLbl);
                } else {
                    transLbl = menuItem.key+'.label.'+menuItem.key;
                    if(transLbl != t(transLbl)) {
                        menuLbl = t(transLbl);
                    }
                }
                return(
              <SidebarItem key={menuItem.key} id={menuItem.key} to={menuItem.route}>
                <HomeIcon />
                <SidebarLabel>{t(menuLbl)}</SidebarLabel>
              </SidebarItem>
            )})}
            </SidebarSection>
            <CalenderEventWidget />
            {props?.authReducer?.megaadminmenu &&
            <SidebarSection>
                <SidebarLabel>MEGA ADMIN</SidebarLabel>
            {props?.authReducer?.megaadminmenu.map((menuItem) => (
              <SidebarItem key={menuItem.key} to={menuItem.route}>
                <HomeIcon />
                <SidebarLabel>{menuItem.label}</SidebarLabel>
              </SidebarItem>
            ))}
            
            </SidebarSection>
            }
              {props?.authReducer?.tenant?.knowledge_website &&
            <SidebarSection className="">
              <SidebarItem href={props?.authReducer?.tenant?.knowledge_website}>Naar kennis website</SidebarItem>
                </SidebarSection>              
              }
            <SidebarSection className="max-lg:hidden hidden">
              <SidebarHeading>Upcoming Events</SidebarHeading>
              <SidebarItem href="/events/1">Bear Hug: Live in Concert</SidebarItem>
              <SidebarItem href="/events/2">Viking People</SidebarItem>
              <SidebarItem href="/events/3">Six Fingers — DJ Set</SidebarItem>
              <SidebarItem href="/events/4">We All Look The Same</SidebarItem>
            </SidebarSection>
            <SidebarSpacer />
            <SidebarSection>
              <SidebarItem href="/support">
                <QuestionMarkCircleIcon />
                <SidebarLabel>Support</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
          </SidebarBody>
          <SidebarFooter className="max-lg:hidden">
            <Dropdown>
              <DropdownButton as={SidebarItem}>
                <span className="flex min-w-0 items-center gap-3">
                  <span className="min-w-0">
                    <span className="block truncate text-sm/5 font-medium text-zinc-950 dark:text-white">{props.authReducer.user.first_name}</span>
                    <span className="block truncate text-xs/5 font-normal text-zinc-500 dark:text-zinc-400">
                      {props.authReducer.user.email}
                    </span>
                  </span>
                </span>
                <ChevronUpIcon />
              </DropdownButton>
              <DropdownMenu className="min-w-64" anchor="top start">
                <DropdownItem to="/myprofile">
                  <DropdownLabel>Mijn profiel</DropdownLabel>
                </DropdownItem>
                <DropdownDivider />
                <DropdownItem onClick={(ev) => logout(ev)}>
                  <ArrowRightStartOnRectangleIcon />
                  <DropdownLabel>Uitloggen</DropdownLabel>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </SidebarFooter>
        </Sidebar>
      }
      floatPanel={
          <LogController />
      }
    >
    <MenuController />
      {props.children}
      
        
    </SidebarLayout>
    
  )
}